/**
 * AnswerCCReceiver ("Kopimodtager af epikrise", XREF01/XREF02): the unit gets a
 * copy of the epikrise, typically the patient's own GP. It must accept an
 * epikrise (DIS01 EDIFACT or XDIS01 XML), not a referral: a lægepraksis does
 * not receive XREF01/XREF02, so filtering on those hid every GP.
 */
export const EPIKRISE_RECEIVE_TYPES = ['DIS01', 'XDIS01'] as const;

export function receivesEpikrise(organisation: { ediReceiveTypes: readonly string[] | null | undefined }): boolean {
  const types = organisation.ediReceiveTypes ?? [];
  return EPIKRISE_RECEIVE_TYPES.some((type) => types.includes(type));
}

/**
 * DIS01-S 4.29 (G9): the SOR unit that is the referral's AnswerCCReceiver —
 * same identifier (and identifier code when both carry one) and able to take
 * the epikrise kind. null when SOR has no such unit.
 */
export function matchReferralCcReceiver<T extends { identifier: string | null; identifierCode: string | null; ean: string }>(
  cc: { identifier?: string; identifierCode?: string } | null | undefined,
  candidates: readonly T[],
  accepts: (organisation: T) => boolean,
): T | null {
  const identifier = cc?.identifier?.trim();
  if (!identifier) return null;
  return (
    candidates.find(
      (o) =>
        o.identifier === identifier &&
        (!cc?.identifierCode || !o.identifierCode || o.identifierCode === cc.identifierCode) &&
        o.ean.length > 0 &&
        accepts(o),
    ) ?? null
  );
}
